export default __webpack_public_path__ + "static/media/Groupe 9130.1587560f.svg";